import { supabase } from '../lib/supabase';

export type InteractionKey =
  | 'modo_personalizado'
  | 'modo_automatico'
  | 'modelo_automatico'
  | 'modelo_personalizado'
  | 'modelo_guardado'
  | 'historial'
  | 'generar_mas'
  | 'repetir_generacion'
  | 'imagenes_editadas'
  | 'escena_prompt'
  | 'texto_personalizado';

export function trackInteraction(key: InteractionKey): void {
  try {
    void supabase
      .rpc('increment_interaccion', { p_key: key })
      .then(
        () => {},
        () => {}
      );
  } catch {}
}
